import { useCallback } from 'react';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   StyledFlex,
   Text,
} from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { AuthenticateAction } from './AccountAuthorizationModal.actions';
import { AccountAuthorizationForm } from './form/AccountAuthorizationForm';

type AccountAuthorizationProps = {
   readonly onClose: VoidFunction;
   readonly onAuthorization?: () => Promise<unknown> | void;
};

export const AccountAuthorizationModal = (props: AccountAuthorizationProps): JSX.Element => {
   const { onAuthorization, onClose } = props;
   const handleAuthenticateActionSuccess = useCallback(async () => {
      await onAuthorization?.();
      onClose();
   }, [onAuthorization, onClose]);

   return (
      <Modal
         title={translationKeys.additionalVerificationRequired}
         width={ModalWidth.NORMAL}
         testId={'accountAuthorization'}
      >
         <StyledFlex direction={'column'} gap={'8px'}>
            <Text testId={'confirmActionByPassword'}>
               <Translate>{translationKeys.confirmActionByPassword}</Translate>
            </Text>
            <AccountAuthorizationForm>
               {({ formState, handleSubmit, setIncorrectPersonalPasswordError }) => (
                  <>
                     <AuthenticateAction
                        onSuccess={handleAuthenticateActionSuccess}
                        onLoginFault={setIncorrectPersonalPasswordError}
                     >
                        {({ authenticate }) => (
                           <ModalConfirmButton label={translationKeys.authorize} onClick={handleSubmit(authenticate)} />
                        )}
                     </AuthenticateAction>
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </AccountAuthorizationForm>
         </StyledFlex>
      </Modal>
   );
};
